// extracted by mini-css-extract-plugin
export var actions = "_cr-d";
export var benefitCard = "_cr-a";
export var benefitIcon = "_cr-b";
export var benefitLabel = "_cr-c";
export var benefits = "_cr-9";
export var bodyText = "_cr-8";
export var closeButton = "_cr-2";
export var content = "_cr-3";
export var eyebrow = "_cr-4";
export var heading = "_cr-5";
export var image = "_cr-f";
export var imagePanel = "_cr-e";
export var modal = "_cr-0";
export var shell = "_cr-1";
export var title = "_cr-6";
export var titleOffer = "_cr-7";